<div class="col-lg-12">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center p-3 globalborder-btm-header">
        <span class="col-auto">
          <h2 class="mb-0">
            Inventory Purchases

            <!-- <jni-spinner *ngIf="showSmallLoader"></jni-spinner> -->
          </h2>
        </span>
      </span>

      <div class="col-12 p-3 adduser-container-hgt">
        <form action="#" [formGroup]="samplePOForm" class="label-fontsize">
          <div class="gray-bg-rounded">
            <div class="row" formGroupName="header">
              <div class="col mb-2 vendor-account">
                <div class="form-group has-float-label">
                  <label class="form-label"
                    >3PL<span class="madatory-field">*</span></label
                  >
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    id="vendoraccount"
                    name="vendoraccount"
                    class="form-control"
                    [value]="vendorAccountNumber"
                    formControlName="vendorAccountNumber"
                    (input)="searchVendor$.next($any($event.target).value)"
                    (keyup)="vendorPopover.show($event)"
                    [ngClass]="{
                      'has-error': formErrors['vendorAccountNumber'],
                    }"
                    (blur)="logValidationErrors()" />

                  <span
                    class="error-msg"
                    *ngIf="formErrors['vendorAccountNumber']">
                    {{ formErrors["vendorAccountNumber"] }}
                  </span>
                </div>
                <p-popover #vendorPopover aria-labelledby="dropdownBasic1">
                  <p-table
                    #dt
                    [value]="vendorList"
                    styleClass="p-datatable-customers po-small"
                    [rowHover]="true"
                    [rows]="10"
                    [showCurrentPageReport]="true"
                    [rowsPerPageOptions]="[10, 25, 50]"
                    [paginator]="false"
                    [filterDelay]="0">
                    <ng-template pTemplate="header">
                      <tr>
                        <th class="name">Name</th>
                        <th class="vaccount">3PL</th>
                        <th class="sname">Search name</th>
                        <th class="phone">Phone</th>
                        <th class="city">City</th>
                        <th class="state">State</th>
                        <th class="country">Country</th>
                      </tr>
                    </ng-template>
                    <ng-template
                      pTemplate="body"
                      let-vendorList
                      let-rowIndex="rowIndex">
                      <tr
                        class="p-selectable-row mousepointer"
                        (click)="
                          onVendorRowSelection(vendorList, vendorPopover)
                        ">
                        <td class="name mousepointer">
                          {{ vendorList.vendorName }}
                        </td>
                        <td class="vaccount mousepointer">
                          {{ vendorList.vendorAccountNumber }}
                        </td>
                        <td class="sname mousepointer">
                          {{ vendorList.vendorSearchName }}
                        </td>
                        <td class="phone mousepointer">
                          {{ vendorList.phoneNumber }}
                        </td>
                        <td class="city mousepointer">
                          {{ vendorList.city }}
                        </td>
                        <td class="state mousepointer">
                          {{ vendorList.state }}
                        </td>
                        <td class="country mousepointer">
                          {{ vendorList.country }}
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="20">No vendor found.</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </p-popover>
              </div>

              <div class="col-3 mb-2 d-flex align-items-top">
                <div class="form-group has-float-label me-2 date-field">
                  <!-- <input pInputText 
              jniAutoCompleteBlocker
              id="shipdate"
              name="shipdate"
              class="form-control"
              [min]="shipDateCurrentdate | date: 'yyyy-MM-dd'"
              (change)="onShipDateSelection($event)"
              onfocus="(this.type='date')"
              onblur="if(!this.value) this.type='text'"
            /> -->
                  <label class="form-label">Ship date</label>
                  <p-datepicker
                    jniAutoCompleteBlocker
                    inputId="basic"
                    class="date-input"
                    (onSelect)="onShipDateSelection($event)"
                    formControlName="expectedStoreAvailableSalesDateD365"
                    [minDate]="shipDateCurrentdate"
                    [showOtherMonths]="true"
                    [selectOtherMonths]="true"></p-datepicker>
                </div>
                <div class="form-group has-float-label me-2 date-field">
                  <!-- <input pInputText 
              jniAutoCompleteBlocker
              id="inhandsdate"
              name="inhandsdate"
              class="form-control"
              [min]="inHandDateCurrentdate | date: 'yyyy-MM-dd'"
              (change)="onInHandDateSelection($event)"
              onfocus="(this.type='date')"
              onblur="if(!this.value) this.type='text'"
            /> -->
                  <label class="form-label">In Hands date</label>
                  <p-datepicker
                    jniAutoCompleteBlocker
                    inputId="basic"
                    class="date-input"
                    (onSelect)="onInHandDateSelection($event)"
                    formControlName="expectedStoreReceiptDateD365"
                    [minDate]="inHandDateCurrentdate"
                    [showOtherMonths]="true"
                    [selectOtherMonths]="true"></p-datepicker>

                  <span
                    class="error-msg"
                    *ngIf="formErrors['expectedStoreReceiptDateD365']">
                    {{ formErrors["expectedStoreReceiptDateD365"] }}
                  </span>
                </div>
                <!-- <div class="form-check">
          <label class="firm">Firm</label>
          <input pInputText 
            type="checkbox"
            class="form-check-input m-0 no-bg"
            formControlName="firm"
            (click)="onFirmChange($event)"
          />
        </div> -->
              </div>
              <div class="col mb-2">
                <div class="form-group has-float-label">
                  <label class="form-label">Job name</label>
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control"
                    placeholder=""
                    formControlName="jobNameD365"
                    [ngClass]="{ 'has-error': formErrors['jobNameD365'] }"
                    (blur)="logValidationErrors()" />

                  <span class="error-msg" *ngIf="formErrors['jobNameD365']">
                    {{ formErrors["jobNameD365"] }}
                  </span>
                </div>
              </div>
              <!-- <div class="col mb-2">
        <div class="form-group has-float-label">
          <input pInputText 
            jniAutoCompleteBlocker
            type="text"
            class="form-control"
            placeholder=""
            formControlName="customerRef365"
            [ngClass]="{ 'has-error': formErrors.customerRef }"
            (blur)="logValidationErrors()"
          />
          <label class="form-label">Customer Ref</label>
          <span class="error-msg" *ngIf="formErrors.customerRef">
            {{ formErrors.customerRef }}
          </span>
        </div>
      </div> -->
              <div class="col mb-2">
                <div class="form-group has-float-label">
                  <!-- <ng-select class="p-0" id="storeD365" formControlName="storeD365" (change)="onOwnerDropDownChange($event)">
            <ng-option *ngFor="let com of filteredStoresField" [value]="com.name">
              <span [title]="com.name">
                {{ com.name }}
              </span>
            </ng-option>
          </ng-select> -->
                  <label class="form-label">Store</label>
                  <p-select
                    pInputText
                    formControlName="storeD365"
                    (onChange)="onOwnerDropDownChange($event)"
                    [options]="filteredStoresField"
                    [filter]="true"
                    optionValue="name"
                    optionLabel="name"
                    [showClear]="true">
                  </p-select>

                  <span class="error-msg" *ngIf="formErrors['storeD365']">
                    {{ formErrors["storeD365"] }}
                  </span>
                </div>
              </div>
              <div class="col mb-2">
                <div class="form-group has-float-label">
                  <!-- <ng-select class="p-0" id="owner" formControlName="ownerD365"> -->
                  <!-- <ng-option
              *ngFor="let com of filtered_owner_list"
              [value]="com.value">
              <span [title]="com.value">
                {{ com.value }}
              </span>
            </ng-option>
          </ng-select> -->
                  <label class="form-label">Owner</label>
                  <p-select
                    formControlName="ownerD365"
                    [options]="filtered_owner_list"
                    [filter]="true"
                    optionValue="value"
                    optionLabel="value"
                    [showClear]="true">
                  </p-select>

                  <span class="error-msg" *ngIf="formErrors['ownerD365']">
                    {{ formErrors["ownerD365"] }}
                  </span>
                </div>
              </div>

              <div class="col mb-2">
                <div class="form-group has-float-label">
                  <!-- <ng-select class="p-0" id="siteD365" formControlName="siteD365" (change)="onSelectionChange($event, 'site')">
            <ng-option *ngFor="let com of siteField" [value]="com.name">
              <span [title]="com.name">
                {{ com.name }}
              </span>
            </ng-option>
          </ng-select> -->
                  <label class="form-label">Site</label>
                  <p-select
                    formControlName="siteD365"
                    id="siteD365"
                    [options]="siteField"
                    [filter]="true"
                    optionValue="name"
                    optionLabel="name"
                    [showClear]="true"
                    (onChange)="onSelectionChange($event, 'site')">
                  </p-select>
                </div>
              </div>
              <div class="col mb-2">
                <div class="form-group has-float-label">
                  <!-- <ng-select class="p-0" id="warehouseD365" formControlName="warehouseD365"
            (change)="onSelectionChange($event, 'warehouse')">
            <ng-option *ngFor="let com of warehouseField" [value]="com.name">
              <span [title]="com.name">
                {{ com.name }}
              </span>
            </ng-option>
          </ng-select> -->
                  <label class="form-label">Warehouse</label>
                  <p-select
                    formControlName="warehouseD365"
                    (onChange)="onSelectionChange($event, 'warehouse')"
                    id="warehouseD365"
                    [options]="warehouseField"
                    [filter]="true"
                    optionValue="name"
                    optionLabel="name"
                    [showClear]="true">
                  </p-select>

                  <span class="error-msg" *ngIf="formErrors['warehouseD365']">
                    {{ formErrors["warehouseD365"] }}
                  </span>
                </div>
              </div>

              <div class="col mb-2 brand-conslt">
                <div class="form-group has-float-label">
                  <label class="form-label"
                    >Branding Consultant<span class="madatory-field"
                      >*</span
                    ></label
                  >
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    id="brandingConsultant"
                    name="brandingConsultant"
                    class="form-control"
                    formControlName="brandingConsultantIdD365"
                    [ngClass]="{
                      'has-error': formErrors['brandingConsultant'],
                    }"
                    (blur)="logValidationErrors()"
                    (click)="bcPopover.toggle($event)" />

                  <span
                    class="error-msg"
                    *ngIf="formErrors['brandingConsultantIdD365']">
                    {{ formErrors["brandingConsultantIdD365"] }}
                  </span>
                  <p-popover #bcPopover>
                    <p-scroller style="height: 200px">
                      <p-table
                        #dt
                        [value]="brandingConsultantLists"
                        styleClass="p-datatable-customers"
                        [rowHover]="true"
                        [rows]="10"
                        [showCurrentPageReport]="true"
                        [rowsPerPageOptions]="[10, 25, 50]"
                        [paginator]="false"
                        [filterDelay]="0">
                        <ng-template pTemplate="header">
                          <tr>
                            <th class="name">Project id</th>
                            <th class="vaccount">Project name</th>
                          </tr>
                        </ng-template>
                        <ng-template
                          pTemplate="body"
                          let-brandingConsultantList
                          let-rowIndex="rowIndex">
                          <tr
                            class="p-selectable-row mousepointer"
                            (click)="
                              onProjectIdSelection(
                                brandingConsultantList,
                                bcPopover
                              )
                            ">
                            <td class="name mousepointer">
                              {{ brandingConsultantList?.projectId }}
                            </td>
                            <td class="name mousepointer">
                              {{ brandingConsultantList.projectName }}
                            </td>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                          <tr>
                            <td colspan="20">No project found.</td>
                          </tr>
                        </ng-template>
                      </p-table>
                    </p-scroller>
                  </p-popover>
                </div>
              </div>
              <div class="col mb-2">
                <div class="form-group has-float-label">
                  <!-- <ng-select [(ngModel)]="bacUserDefaultSelectionId" class="p-0" formControlName="accountCoordinatorD365">
            <ng-option *ngFor="let com of bacList" [value]="com.personnelNumber">
              {{ com.personnelNumber }} : {{ com.name }}
            </ng-option>
          </ng-select> -->
                  <label class="form-label">Accounts coordinator</label>
                  <p-select
                    formControlName="accountCoordinatorD365"
                    (onChange)="onCurrencyConversion()"
                    [options]="bacList"
                    [filter]="true"
                    optionValue="personnelNumber"
                    [showClear]="true">
                    <ng-template #selectedItem let-selectedOption>
                      {{ selectedOption.personnelNumber }} :
                      {{ selectedOption.name }}
                    </ng-template>
                    <ng-template let-country #item>
                      {{ country.personnelNumber }} : {{ country.name }}
                    </ng-template>
                  </p-select>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col">
              <div class="row">
                <div class="col-4">
                  <div class="gray-bg-rounded" formGroupName="header">
                    <h3 class="mb-2">Vendor</h3>
                    <div
                      class="form-group has-float-label mb-2"
                      (click)="onVendorModal()">
                      <label class="form-label">Vendor name</label>
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        class="form-control has-link"
                        placeholder=""
                        formControlName="vendorName" />
                    </div>
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label">Vendor Address</label>
                      <textarea
                        pInputText
                        rows="5"
                        jniAutoCompleteBlocker
                        placeholder=""
                        class="form-control"
                        formControlName="vendorAddress"></textarea>
                    </div>
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label">Phone number</label>
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        class="form-control"
                        placeholder=""
                        formControlName="vendorPhone" />
                    </div>
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label">Email Address</label>
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="email"
                        class="form-control"
                        placeholder=""
                        formControlName="vendorEmail" />
                    </div>
                  </div>
                </div>

                <div class="col-4">
                  <div class="gray-bg-rounded">
                    <h3 class="mb-2">Ship to</h3>
                    <jni-inventory-purchase-ship-to-address
                      #samplepoaddress
                      [parent]="samplePOForm"
                      [formgroupName]="'addressInformation'"
                      [brandingConsultantObject]="brandingConsultantObject"
                      [customerBillToObject]="customerBillToObject"
                      [deliveryAddress]="deliveryAddress"
                      [cityList]="cityList"
                      [countryRegionList]="countryRegionList"
                      [countyList]="countyList"
                      [districtList]="districtList"
                      [formErrors]="formErrors"
                      [validationMessages]="validationMessages"
                      [addressField]="addressField"
                      (validationErrorEvent)="logValidationErrors()">
                    </jni-inventory-purchase-ship-to-address>
                  </div>
                </div>
                <div class="col-4">
                  <div class="gray-bg-rounded" formGroupName="header">
                    <h3 class="mb-2">Details</h3>
                    <div class="form-group has-float-label mb-2">
                      <div class="form-group has-float-label">
                        <!-- <ng-select class="p-0" id="currency" formControlName="deliveryModeIdD365"
                  (change)="onShippingMethodSelect($event)">
                  <ng-option *ngFor="let com of shippingProductsList" [value]="com.modeCodeD365">
                    <span [title]="com.modeDescriptionD365">
                      {{ com.modeDescriptionD365 }}
                    </span>
                  </ng-option>
                </ng-select> -->
                        <label class="form-label">Shipping Method</label>
                        <p-select
                          formControlName="deliveryModeIdD365"
                          id="shipping"
                          (onChange)="onShippingMethodSelect($event)"
                          [options]="shippingProductsList"
                          [filter]="true"
                          optionValue="modeCodeD365"
                          optionLabel="modeDescriptionD365"
                          [showClear]="true">
                        </p-select>
                      </div>
                    </div>
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label">Account #</label>
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        class="form-control"
                        placeholder=""
                        formControlName="accountNumber" />
                    </div>
                    <div
                      class="form-group has-float-label mb-2 d-flex align-items-center">
                      <input
                        pInputText
                        class="form-check-input me-2 mt-0 no-bg"
                        type="checkbox"
                        formControlName="isnetInForeignCurrencyStatus"
                        (click)="onCurrencyEnable($event)" />
                      <div class="form-group has-float-label flex-grow-1">
                        <!-- <ng-select class="p-0" id="currency" formControlName="currencyCodeD365"
                  (change)="onCurrencyConversion()">
                  <ng-option *ngFor="let com of currencyList" [value]="com.isoCurrencyCodeD365">
                    {{ com.isoCurrencyCodeD365 }}
                  </ng-option>
                </ng-select> -->
                        <label class="form-label"
                          >Net in Foreign Currency</label
                        >
                        <p-select
                          formControlName="currencyCodeD365"
                          id="currency"
                          (onChange)="onCurrencyConversion()"
                          [options]="currencyList"
                          [filter]="true"
                          optionValue="isoCurrencyCodeD365"
                          optionLabel="isoCurrencyCodeD365"
                          [showClear]="true">
                        </p-select>
                      </div>
                    </div>
                    <label>Inventory Purchases:</label>
                    <div class="form-check form-switch">
                      <p-toggleswitch
                        [(ngModel)]="inventoryPurchCheck"
                        [ngModelOptions]="{ standalone: true }"
                        [disabled]="true"
                        id="tAssumption"
                        name="tAssumption" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex py-3 justify-content-end has-sticky gap-3">
            <!-- <button
              type="button"
              class="btn btn-secondary me-3"
              (click)="onCancel()">
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary"
              (click)="addSamplePoScreen()">
              Save
            </button> -->

            <p-button
              label="Cancel"
              (click)="onCancel()"
              variant="outlined"
              severity="secondary" />

            <p-button label="Save" (click)="addSamplePoScreen()" />
          </div>
        </form>
      </div>
    </p-card>
  </div>
</div>

<!-- <div class="samplepo py-4">
  <header class="samplepo-header has-border d-flex pb-2 mb-2">
    <h1 class="m-0">Inventory Purchases</h1>
    <div class="lds-ring inline me-auto ms-2" *ngIf="showSmallLoader">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </header>
</div> -->
